<template>
    <div v-if="indicators.length" class="my-3 d-flex scroll hide-scrollbar">
        <IndicatorSmall
            v-for="indicator in indicators"
            :key="indicator.id"
            :title="indicator.title"
            :value="indicator.count"
        />
    </div>
</template>
<script>
import SampleTypeCollection from "@/collections/lab/SampleTypeCollection";
import IndicatorSmall from "@/components/shared/IndicatorSmall.vue";

export default {
    name: "ScheduleIndicatorTiles",
    components: {
        IndicatorSmall
    },
    data() {
        return {
            indicators: [],
            sampleCount: [],
        };
    },
    methods: {
        async init() {
            await this.setupIndicators();
        },
        async setupIndicators() {
            const sampleTypeCollection = new SampleTypeCollection();
            const sampleCount = await sampleTypeCollection.getIndicatorCount();
            this.sampleCount = sampleCount.response.data
        },
    },
    watch: {
        sampleCount: {
            handler() {
                this.indicators = this.sampleCount.map(({sample_type, count}) => {
                    return {
                        count, 
                        title: sample_type.name,
                        id: sample_type.id,
                    }
                });
            },
            immediate: true,
            deep:true,
        }
    },
    async mounted() {
        await this.init();
    }
}
</script>
<style>
    .scroll {
        overflow: scroll;
        overflow-y: hidden;
    }

    @media (min-width: 1450px) {
        .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
        }

        .hide-scrollbar::-webkit-scrollbar {
            display: none;
        }
    }
</style>